import { ChangeDetectionStrategy, Component } from '@angular/core';

interface DisclaimerSection {
  id: string;
  title: string;
  body: string;
}

interface DisclaimerContent {
  title: string;
  sections: DisclaimerSection[];
}

@Component({
  selector: 'app-disclaimer-page',
  templateUrl: './disclaimer-page.component.html',
  styleUrl: './disclaimer-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisclaimerPageComponent {
  // Common JSON used for both desktop and ≤1024px layouts.
  readonly content: DisclaimerContent = {
    title: 'AskPC Disclaimer',
    sections: [
      {
        id: '1',
        title: '1. Nature of Service and No Professional Advice',
        body:
          'The information provided by AskPC.PrivateCircle (the "Service") is generated by an artificial intelligence system and is for informational and research purposes only. It does not constitute financial, investment, legal, tax, or accounting advice.\n\n' +
          "AskPC or PrivateCircle is not a Registered Investment Advisor (RIA), broker-dealer, or fiduciary. No part of the Service's output should be construed as a recommendation to buy, sell, or hold any security or to engage in any specific investment strategy",
      },
      {
        id: '2',
        title: '2. Accuracy and "As-Is" Warranty',
        body:
          'Private market data is inherently fragmented, opaque, and often subject to reporting lags. You acknowledge that:\n\n' +
          'Data Integrity: Output may be based on estimates, third-party reports, or unstructured data that has not been independently verified.\n\n' +
          'Hallucinations: AI agents may generate "hallucinations" or factually incorrect statements.\n\n' +
          'No Warranty: The Service is provided on an "AS IS" and "AS AVAILABLE" basis. PrivateCircle disclaims all warranties, express or implied, regarding the accuracy, completeness, or fitness for a particular purpose of the data provided.',
      },
      {
        id: '3',
        title: '3. Assumption of Risk and Independent Verification',
        body:
          'You assume all risks associated with the use of the Service. It is your sole responsibility to:\n\n' +
          'Independently verify any data points, valuations, or company information through primary sources (e.g. MCA Filings, Exchange filings, audited financial statements, or direct due diligence).\n\n' +
          'Exercise professional judgment before making any financial commitments or business decisions.',
      },
      {
        id: '4',
        title: '4. Limitation of Liability',
        body: 'To the maximum extent permitted by law, PrivateCircle, its affiliates, and its data providers shall not be liable for any direct, indirect, incidental, consequential, or punitive damages, including but not limited to loss of profits, capital, or data, arising out of your use of or inability to use the Service, even if advised of the possibility of such damages.',
      },
      {
        id: '5',
        title: '5. Data Privacy and User Inputs',
        body:
          'Prohibited Content: You are strictly prohibited from inputting Personal Identifiable Information (PII), sensitive personal data, or proprietary trade secrets into the Service.\n\n' +
          'Input Usage: AskPC User queries and interactions may be used to improve the performance of the AI products and models. Do not share information you wish to remain confidential.',
      },
      {
        id: '6',
        title: '6. Third-Party Data Sources',
        body: 'The Service may aggregate data from third-party providers. Your use of this data is subject to the terms and conditions of those respective providers. PrivateCircle does not guarantee the uptime or accuracy of these third-party integrations.',
      },
    ],
  };
}
